import { Suspense } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { mainSelectors } from "stores/mainSlice";
import { connect } from "react-redux";
import { PONERA_ROUTES } from "routes";

export function RequireNoAuthInner(props) {
  const location = useLocation();
  const isLogged = props.user; // || sessionStorage.getItem("ulg") === "1";
  return isLogged ? (
    <Navigate to={PONERA_ROUTES.DASHBOARD} state={{ from: location }} replace />
  ) : (
    <Suspense fallback={<div>Loading...</div>}>
      <Outlet />
    </Suspense>
  );
}

const mapStateToProps = (state) => {
  return {
    userSelector: mainSelectors.userSelector(state),
  };
};

const mapDispatchToProps = {};

const RequireNoAuth = connect(
  mapStateToProps,
  mapDispatchToProps
)(RequireNoAuthInner);

export default RequireNoAuth;
